/* eslint-disable */
import dayjs from 'dayjs';
import Dexie from 'dexie';

const tables = {
  serviceOrderPhoto: 'serviceOrderPhoto',
  serviceOrderChecklistItemPhoto: 'serviceOrderCehcklistItemPhoto',
  parameters: 'parameters'
};

const dexieDB = new Dexie('CheckMotors');

// Versão 8 - compatibilidade com versões anteriores
dexieDB.version(8).stores({
  [tables.serviceOrderPhoto]: '++id, service_order, tag, media, type, observation, created_at, visible, attempts',
  [tables.serviceOrderChecklistItemPhoto]:
    '++id, service_order, checklist, [service_order+checklist], checklist_item, checklist_item_value, type, tag, media, created_at, attempts',
  [tables.parameters]: '++id, name, value'
});

// Versão 9 - versão atual
dexieDB.version(9).stores({
  [tables.serviceOrderPhoto]: '++id, service_order, tag, media, type, observation, created_at, visible, attempts',
  [tables.serviceOrderChecklistItemPhoto]:
    '++id, service_order, checklist, [service_order+checklist], checklist_item, checklist_item_value, type, tag, media, created_at, attempts',
  [tables.parameters]: '++id, name, value'
});

// Versão 10 e superiores - para compatibilidade com versões futuras
for (let version = 10; version <= 100; version++) {
  dexieDB.version(version).stores({
    [tables.serviceOrderPhoto]: '++id, service_order, tag, media, type, observation, created_at, visible, attempts',
    [tables.serviceOrderChecklistItemPhoto]:
      '++id, service_order, checklist, [service_order+checklist], checklist_item, checklist_item_value, type, tag, media, created_at, attempts',
    [tables.parameters]: '++id, name, value'
  });
}

dexieDB.addServiceOrderPhoto = function(serviceOrderPhoto) {
  return this.table(tables.serviceOrderPhoto).add(serviceOrderPhoto);
};

dexieDB.checkPendingServiceOrderPhoto = function(serviceOrder) {
  return this.table(tables.serviceOrderPhoto).where('service_order').equals(serviceOrder).toArray();
};

dexieDB.removeServiceOrderPhoto = function(id) {
  return this.table(tables.serviceOrderPhoto).delete(id);
};

dexieDB.removeServiceOrderPhotoByTag = async function(serviceOrder, tag) {
  const filteredRecords = await this.table(tables.serviceOrderPhoto).where('service_order').equals(serviceOrder).toArray();
  const recordsToDelete = filteredRecords.filter((record) => record.tag === tag);
  for (const record of recordsToDelete) {
    await this.table(tables.serviceOrderPhoto).delete(record.id);
  }
  return recordsToDelete.length;
};

dexieDB.incrementAttempts = async function(id) {
  const record = await this.table(tables.serviceOrderPhoto).get(id);

  if (record) {
    const newAttemptsValue = (record.attempts || 0) + 1;
    await this.table(tables.serviceOrderPhoto).update(id, { attempts: newAttemptsValue });
  }
};

dexieDB.removeAttempts = async function(id) {
  const record = await this.table(tables.serviceOrderPhoto).get(id);

  if (record) {
    await this.table(tables.serviceOrderPhoto).update(id, { attempts: null });
  }
};

dexieDB.removeAttemptsByTag = async function(serviceOrder, tag) {
  const filteredRecords = await this.table(tables.serviceOrderPhoto).where('service_order').equals(serviceOrder).toArray();
  const recordsToUpdate = filteredRecords.filter((record) => record.tag === tag);
  for (const record of recordsToUpdate) {
    await this.table(tables.serviceOrderPhoto).update(record.id, { attempts: null });
  }
  return recordsToUpdate.length;
};

dexieDB.addServiceOrderChecklistItemPhoto = function(itemPhoto) {
  return this.table(tables.serviceOrderChecklistItemPhoto).add(itemPhoto);
};

dexieDB.checkPendingServiceOrderChecklistItemsPhoto = async function(serviceOrder, checklist) {
  return this.table(tables.serviceOrderChecklistItemPhoto).where({ service_order: serviceOrder, checklist: checklist }).toArray();
};

dexieDB.removeAttemptsServiceOrderChecklistItem = async function(id) {
  const record = await this.table(tables.serviceOrderChecklistItemPhoto).get(id);

  if (record) {
    await this.table(tables.serviceOrderChecklistItemPhoto).update(id, { attempts: null });
  }
};

dexieDB.removeServiceOrderChecklistItemPhoto = function(id) {
  return this.table(tables.serviceOrderChecklistItemPhoto).delete(id);
};

dexieDB.jobRemoveOldPhotos = async function(hoursToBackup) {
  const photos = await this.table(tables.serviceOrderPhoto).toArray();

  const checklistItemPhotos = await this.table(tables.serviceOrderChecklistItemPhoto).toArray();

  if (!photos.length && !checklistItemPhotos.length) return;

  const now = dayjs();

  const promises = [];

  photos.forEach(({ id, created_at }) => {
    const diffInHours = now.diff(dayjs(created_at), 'hours');

    if (diffInHours > hoursToBackup) {
      promises.push(this.table(tables.serviceOrderPhoto).delete(id));
    }
  });

  checklistItemPhotos.forEach(({ id, created_at }) => {
    const diffInHours = now.diff(dayjs(created_at), 'hours');

    if (diffInHours > hoursToBackup) {
      promises.push(this.table(tables.serviceOrderChecklistItemPhoto).delete(id));
    }
  });

  if (promises.length) {
    await Promise.all(promises);
  }
};

dexieDB.clearServiceOrderPhoto = function() {
  return this.table(tables.serviceOrderPhoto).clear();
};

dexieDB.getParameters = function() {
  return this.table(tables.parameters).toArray();
};

dexieDB.upsertParameter = async function(parameter, value) {
  const parameterExists = await this.table(tables.parameters).where('name').equals(parameter).first();

  if (!parameterExists) {
    return this.table(tables.parameters).add({
      name: parameter,
      value
    });
  }

  return this.table(tables.parameters).update(parameterExists.id, { value });
};

// Função para resolver conflitos de versão
dexieDB.resolveVersionConflict = async function() {
  try {
    console.log('Resolvendo conflito de versão do banco...');
    await this.delete();
    console.log('Banco removido. Recarregando página...');
    window.location.reload();
  } catch (error) {
    console.error('Erro ao resolver conflito de versão:', error);
    // Como último recurso, limpar IndexedDB manualmente
    if ('indexedDB' in window) {
      indexedDB.deleteDatabase('CheckMotors');
      setTimeout(() => window.location.reload(), 1000);
    }
  }
};

export default dexieDB;
